export const GET_HISTORY_REQUEST = "GET_HISTORY_REQUEST";
export const GET_HISTORY_REQUEST_SUCCEEDED = "GET_HISTORY_REQUEST_SUCCEEDED";
export const GET_HISTORY_REQUEST_FAILED = "GET_HISTORY_REQUEST_FAILED";
